'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';

import { useAnnouncementFlag } from '@/lib/posthog/flags';

import { Button } from '../ui/button';

export const Announcement = (): null => {
  const announcement = useAnnouncementFlag();

  useEffect(() => {
    if (announcement.enabled && announcement.payload) {
      toast.warning(announcement.payload.message, {
        id: 'announcement',
        duration: Number.POSITIVE_INFINITY,
        action: (
          <Button
            size="sm"
            variant="outline"
            className="text-[13px] hover:bg-white/30 hover:text-inherit hover:backdrop-brightness-95 focus-visible:ring-warning/20 dark:bg-transparent dark:focus-visible:ring-warning/40"
            onClick={() => toast.dismiss('announcement')}
          >
            Dismiss
          </Button>
        ),
      });
    }
  }, [announcement]);

  return null;
};
